// src/components/common/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * Wraps any route that requires the user to be logged in.
 * Redirects to /login if not authenticated,
 * and passes the original URL so we can redirect back after login.
 */
export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}

/**
 * Wraps any route that requires admin role.
 * Redirects to / if user is not an admin.
 */
export function AdminRoute({ children }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function LoadingScreen() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#070910",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: "16px",
      fontFamily: "'DM Mono', monospace",
      color: "#00d4ff",
    }}>
      <div style={{ fontSize: "28px", animation: "spin 1s linear infinite" }}>⚡</div>
      <div style={{ fontSize: "12px", letterSpacing: "2px", color: "#556" }}>LOADING...</div>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}